import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class CommonSubjectsService {
  
    readonly alreadyRedirected = signal(false);
    readonly isDebugBar = signal(false);


    setAlreadyRedirected(value: boolean) {
        this.alreadyRedirected.set(value);
    }

    setIsDebugBar(value: boolean) {
        this.isDebugBar.set(value);
    }

}